import { fetchApiAdmin, throwIfNotOk } from './http'
import type { SdsConsumerAsyncJobStatusResponse } from './job-types'
import type { JsonResponse, SdsConsumerOperation } from './types'

type GetSpotfixTournamentSeasonRefreshStatusOperation =
  SdsConsumerOperation<'get-sds-consumer-spotfix-tournament-season-refresh-status'>

export type SpotfixTournamentSeasonRefreshStatusResponse = JsonResponse<
  GetSpotfixTournamentSeasonRefreshStatusOperation,
  SdsConsumerAsyncJobStatusResponse
>

export async function getSpotfixTournamentSeasonRefreshStatus(): Promise<SpotfixTournamentSeasonRefreshStatusResponse> {
  const response = await fetchApiAdmin('/sds-consumer/spotfix/tournament-season/refresh/status', {
    method: 'GET',
  })

  await throwIfNotOk(response)
  return response.json()
}

export const spotfixTournamentSeasonRefreshStatusQuery = () => ({
  queryKey: ['sds-consumer-spotfix-refresh-status'],
  queryFn: getSpotfixTournamentSeasonRefreshStatus,
})
